<div *ngIf="modalShow" class="simple-modal-wrap fixed left-0 bottom-0 full-width z-index-900" [ngClass]="setModal">
  <div class="overlay absolute top-0 left-0 full-width full-height" (click)="closeSModal()" [@isFade]="modalShow"></div>
  <div class="absolute full-width left-0 bottom-0">
    <div
      class="relative simple-modal-content-wrap margin-auto flex row wrap y-items-center padding-15 bg-light-2"
      [ngClass]="{'flex row wrap y-items-center x-content-center txt-center': fullHeight}"
      [@isOpenShow]="modalShow"
    >
      <div>
        <ng-container *ngIf="fullHeight">
          <h4 class="line-height-normal weight-300 dark-3 margin-bottom-10">
            {{modalTitle}}
          </h4>
          <hr />
        </ng-container>
        <div class="simple-modal-content relative-left full-width">
          <ng-content></ng-content>
          <button class="button black sm fine mat-sm" (click)="closeSModal()" mat-button aria-label="Modal close" aria-hidden="true">
            {{closeBtnText}}
          </button>
        </div>
        <button (click)="closeSModal()" class="mat-sm" mat-icon-button aria-label="Modal close icon" aria-hidden="true">
          <mat-icon inline>
            close
          </mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
